<template>
  <div class="trainings">
    <div class="trainings__header">
      <p>Treinamentos</p>
    </div>
    <div class="trainings__list">
      <training-card
        @click="viewTraining(training)"
        v-for="(training, index) in trainings"
        :key="index"
        :training="training"
      ></training-card>
    </div>
    <div class="trainings__all">
      <router-link :to="{ name: 'site.trainings' }">
        VEJA TODOS
        <b-icon icon="chevron-double-right"></b-icon>
      </router-link>
    </div>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';
import TrainingCard from '@/components/Training/TrainingCard.vue';

export default {
  name: 'trainings-carousel',
  components: {
    TrainingCard,
  },
  data: () => {
    return {
      isLoading: false,
      trainings: [],
    };
  },
  methods: {
    loadTrainings() {
      this.isLoading = true;

      TrainingService.get()
        .then((response) => {
          const { data: trainings } = response.data;
          this.trainings = trainings.slice(0, 3);
        })
        .finally(() => (this.isLoading = false));
    },
    viewTraining(training) {
      this.$router.push({
        name: 'site.trainings.view',
        params: { id: training.id },
      });
    },
  },
  beforeMount() {
    this.loadTrainings();
  },
};
</script>

<style lang="scss" scoped>
.trainings {
  &__header {
    p {
      text-align: center;
      color: var(--color-secondary);
      font-weight: bold;
      font-size: 1.8em;
    }
  }

  &__list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;

    .training-card {
      &:not(:last-child) {
        margin-right: 64px;
      }
    }
  }

  &__all {
    margin-top: 48px;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.9em;
      font-weight: 500;
      color: var(--color-primary);

      .icon {
        margin-left: 12px;
        color: var(--text-color);
      }
    }
  }
}

.training-card {
  transition: 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}

@media (max-width: 992px) {
  .trainings {
    &__list {
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .training-card {
        margin: 0;
        
        &:not(:last-child) {
          margin: 0;
          margin-bottom: 1em;
        }
      }
    }
  }
}
</style>
